import { Backend } from '@/_axios';

export default {
  GET_ALL_PROJECTS_WITH_LOGGED_HOURS: function ({ commit }) {
    Backend.get('/api/all-projects-with-logged-hours').then((response) => {
      commit('SET_PROJECTS_WITH_HOURS_BY_USERS', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_LOGGED_HOURS_BY_PROJECT: function ({ commit }) {
    Backend.get('api/get-logged-hours-by-project').then((response) => {
      commit('SET_LOGGED_HOURS_BY_PROJECT', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_PLANNED_HOURS_BY_PROJECT: function ({ commit }) {
    Backend.get('api/get-planned-hours-by-project').then((response) => {
      commit('SET_PLANNED_HOURS_BY_PROJECT', response.data);
    }, (err) => {
      console.log(err);
    });
  },
  GET_PLANNED_HOURS_BY_USER: function ({ commit }) {
    Backend.get('api/get-planned-hours-by-user').then((response) => {
      commit('SET_PLANNED_HOURS_BY_USER', response.data);
    }, (err) => {
      console.log(err);
    });
  }
};
